import { useEffect, useState } from "react";
import api from "../api";
import { guardarFunil } from "../funil";
import { useTheme } from "../components/Theme";

const TIPOS = [["novo", "Entrada"], ["contato", "Em andamento"], ["ganho", "Ganho"], ["perdido", "Perdido"]];
const CORES = ["#579bfc", "#fdab3d", "#66ccff", "#a25ddc", "#cab641", "#784bd1", "#00c875", "#e2445c", "#EE6A1A", "#98A2B3"];
const hex = (c) => (/^#[0-9a-fA-F]{6}$/.test(c || "") ? c : "#98A2B3");

export default function FunilConfig() {
  const { theme } = useTheme();
  const COR = theme.orange || "#EE6A1A";
  const [status, setStatus] = useState([]);
  const [original, setOriginal] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [etapasOriginal, setEtapasOriginal] = useState([]);
  const [podeEditar, setPodeEditar] = useState(false);
  const [modelos, setModelos] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [mover, setMover] = useState(null);
  const [moverEtapa, setMoverEtapa] = useState(null);
  const [msg, setMsg] = useState(null);
  const [msgEtapas, setMsgEtapas] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [salvandoEtapas, setSalvandoEtapas] = useState(false);
  const [novoGrupo, setNovoGrupo] = useState("");

  const carregar = () => {
    api.get("/funil").then((r) => {
      setStatus(r.data.statusLead); setOriginal(r.data.statusLead);
      setEtapas(r.data.etapasNegociacao || []); setEtapasOriginal(r.data.etapasNegociacao || []);
      setPodeEditar(!!r.data.podeEditar);
    }).catch(() => setMsg({ erro: true, t: "Não foi possível carregar o funil." }));
    api.get("/funil/modelos").then((r) => setModelos(r.data.modelos || [])).catch(() => {});
    api.get("/grupos").then((r) => setGrupos(r.data.grupos || [])).catch(() => {});
  };
  useEffect(carregar, []);

  if (!podeEditar) return null;

  const muda = (i, k, v) => setStatus((l) => l.map((s, j) => (j === i ? { ...s, [k]: v } : s)));
  const mudaEtapa = (i, k, v) => setEtapas((l) => l.map((s, j) => (j === i ? { ...s, [k]: v } : s)));
  const move = (lista, i, d) => { const n = [...lista]; const j = i + d; if (j < 0 || j >= n.length) return n; [n[i], n[j]] = [n[j], n[i]]; return n; };
  const alterado = JSON.stringify(status) !== JSON.stringify(original);
  const etapasAlteradas = JSON.stringify(etapas) !== JSON.stringify(etapasOriginal);

  const salvar = async (mapa) => {
    setMsg(null); setSalvando(true);
    try {
      const r = await api.put("/funil", { statusLead: status, mover: mapa || {} });
      setStatus(r.data.statusLead); setOriginal(r.data.statusLead); setMover(null);
      guardarFunil(r.data);
      setMsg({ t: "Funil salvo! Recarregue a tela de Leads para ver as mudanças." });
    } catch (err) {
      const d = err.response?.data || {};
      if (err.response?.status === 409 && d.precisaMover) {
        const destinoPadrao = (status.find((s) => s.tipo === "novo") || status[0] || {}).id || "";
        const m = {}; Object.keys(d.precisaMover).forEach((id) => { m[id] = { qtd: d.precisaMover[id], para: destinoPadrao }; });
        setMover(m);
      } else setMsg({ erro: true, t: d.message || "Erro ao salvar o funil." });
    } finally { setSalvando(false); }
  };

  const salvarEtapas = async (mapa) => {
    setMsgEtapas(null); setSalvandoEtapas(true);
    try {
      const r = await api.put("/funil", { etapasNegociacao: etapas, moverEtapa: mapa || {} });
      setEtapas(r.data.etapasNegociacao); setEtapasOriginal(r.data.etapasNegociacao); setMoverEtapa(null);
      guardarFunil(r.data);
      setMsgEtapas({ t: "Etapas salvas! Recarregue Negociações e Kanban para ver as mudanças." });
    } catch (err) {
      const d = err.response?.data || {};
      if (err.response?.status === 409 && d.precisaMoverEtapa) {
        const destinoPadrao = (etapas.find((s) => s.tipo === "novo") || etapas[0] || {}).id || "";
        const m = {}; Object.keys(d.precisaMoverEtapa).forEach((id) => { m[id] = { qtd: d.precisaMoverEtapa[id], para: destinoPadrao }; });
        setMoverEtapa(m);
      } else setMsgEtapas({ erro: true, t: d.message || "Erro ao salvar as etapas." });
    } finally { setSalvandoEtapas(false); }
  };

  const grupoApi = async (fn) => { try { await fn(); const r = await api.get("/grupos"); setGrupos(r.data.grupos || []); } catch (e) { setMsg({ erro: true, t: "Erro ao salvar o grupo." }); } };
  const reordenarGrupos = (i, d) => { const n = move(grupos, i, d); setGrupos(n); grupoApi(() => api.put("/grupos/reordenar/ordem", { ids: n.map((g) => g._id) })); };

  const card = { background: theme.bgCard || theme.bgInput, border: `1px solid ${theme.border}`, borderRadius: 15, padding: 24, marginTop: 24, fontFamily: "'Inter',-apple-system,sans-serif" };
  const inp = { height: 38, boxSizing: "border-box", padding: "0 10px", borderRadius: 8, border: `1px solid ${theme.border}`, background: theme.bgInput, color: theme.text, fontSize: 14, fontFamily: "inherit" };
  const btnIcone = { width: 32, height: 32, borderRadius: 8, border: `1px solid ${theme.border}`, background: "transparent", color: theme.textSub, cursor: "pointer", fontSize: 14 };
  const btn = (primario) => ({ height: 40, padding: "0 18px", borderRadius: 10, border: primario ? "none" : `1px solid ${theme.border}`, background: primario ? COR : "transparent", color: primario ? "#fff" : theme.text, fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "inherit" });
  const titulo = (t, sub) => (<div style={{ marginBottom: 16 }}><h3 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: theme.text }}>{t}</h3><p style={{ margin: "4px 0 0", fontSize: 14, color: theme.textMuted }}>{sub}</p></div>);
  const quadCor = { width: 38, height: 38, padding: 2, border: `1px solid ${theme.border}`, borderRadius: 8, background: "transparent", cursor: "pointer" };

  return (
    <div>
      <div style={card}>
        {titulo("Funil de Leads", "Os status que aparecem na tela de Leads. O tipo define como cada status entra nos contadores (novos, em contato, convertidos).")}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {status.map((s, i) => (
            <div key={s.id + i} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <input type="color" value={hex(s.color)} onChange={(e) => muda(i, "color", e.target.value)} style={quadCor} />
              <input value={s.label} onChange={(e) => muda(i, "label", e.target.value)} maxLength={40} style={{ ...inp, flex: "1 1 200px" }} />
              <select value={s.tipo || "contato"} onChange={(e) => muda(i, "tipo", e.target.value)} style={{ ...inp, width: 150 }}>
                {TIPOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
              <button type="button" title="Subir" onClick={() => setStatus((l) => move(l, i, -1))} style={btnIcone}>↑</button>
              <button type="button" title="Descer" onClick={() => setStatus((l) => move(l, i, 1))} style={btnIcone}>↓</button>
              <button type="button" title="Remover" onClick={() => setStatus((l) => l.filter((_, j) => j !== i))} style={{ ...btnIcone, color: "#ef4444" }}>✕</button>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 14, alignItems: "center" }}>
          <button type="button" style={btn(false)} onClick={() => setStatus((l) => [...l, { id: "", label: "Novo status", color: CORES[l.length % CORES.length], tipo: "contato" }])}>+ Adicionar status</button>
          {modelos.length > 0 && (
            <select value="" onChange={(e) => { const m = modelos.find((x) => x.id === e.target.value); if (m && window.confirm(`Trocar a lista pelo modelo "${m.nome}"? Nada é salvo até você clicar em Salvar.`)) setStatus(m.statusLead); }} style={{ ...inp, height: 40 }}>
              <option value="">Usar um modelo pronto…</option>
              {modelos.map((m) => <option key={m.id} value={m.id}>{m.nome}</option>)}
            </select>
          )}
          <div style={{ flex: 1 }} />
          {alterado && <button type="button" style={btn(false)} onClick={() => { setStatus(original); setMover(null); }}>Desfazer</button>}
          <button type="button" style={{ ...btn(true), opacity: alterado && !salvando ? 1 : 0.5 }} disabled={!alterado || salvando} onClick={() => salvar()}>{salvando ? "Salvando..." : "Salvar funil"}</button>
        </div>

        {mover && (
          <div style={{ marginTop: 16, padding: 16, borderRadius: 12, border: `1px solid ${COR}55`, background: `${COR}10` }}>
            <div style={{ fontWeight: 700, color: theme.text, marginBottom: 10 }}>Alguns status removidos ainda têm leads. Para onde eles vão?</div>
            {Object.entries(mover).map(([id, v]) => (
              <div key={id} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap", color: theme.textSub, fontSize: 14 }}>
                <span><strong>{(original.find((s) => s.id === id) || { label: id }).label}</strong> ({v.qtd} lead{v.qtd > 1 ? "s" : ""}) → </span>
                <select value={v.para} onChange={(e) => setMover((m) => ({ ...m, [id]: { ...m[id], para: e.target.value } }))} style={inp}>
                  {status.filter((s) => s.id).map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
                </select>
              </div>
            ))}
            {status.some((s) => !s.id) && <div style={{ fontSize: 13, color: theme.textMuted, marginBottom: 8 }}>Status novos só aparecem aqui depois de salvos.</div>}
            <div style={{ display: "flex", gap: 10 }}>
              <button type="button" style={btn(true)} onClick={() => { const mapa = {}; Object.entries(mover).forEach(([id, v]) => { mapa[id] = v.para; }); salvar(mapa); }}>Mover e salvar</button>
              <button type="button" style={btn(false)} onClick={() => setMover(null)}>Cancelar</button>
            </div>
          </div>
        )}
        {msg && <div style={{ marginTop: 14, fontSize: 14, padding: "10px 14px", borderRadius: 10, background: msg.erro ? "#ef444410" : "#00c87514", color: msg.erro ? "#ef4444" : "#00a060" }}>{msg.t}</div>}
      </div>

      <div style={card}>
        {titulo("Etapas do funil de vendas", "As colunas das telas de Negociações e Kanban. É por aqui que a negociação caminha até fechar.")}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {etapas.map((s, i) => (
            <div key={s.id + i} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <input type="color" value={hex(s.color)} onChange={(e) => mudaEtapa(i, "color", e.target.value)} style={quadCor} />
              <input value={s.label} onChange={(e) => mudaEtapa(i, "label", e.target.value)} maxLength={40} style={{ ...inp, flex: "1 1 200px" }} />
              <select value={s.tipo || "contato"} onChange={(e) => mudaEtapa(i, "tipo", e.target.value)} style={{ ...inp, width: 150 }}>
                {TIPOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
              <button type="button" title="Subir" onClick={() => setEtapas((l) => move(l, i, -1))} style={btnIcone}>↑</button>
              <button type="button" title="Descer" onClick={() => setEtapas((l) => move(l, i, 1))} style={btnIcone}>↓</button>
              <button type="button" title="Remover" onClick={() => setEtapas((l) => l.filter((_, j) => j !== i))} style={{ ...btnIcone, color: "#ef4444" }}>✕</button>
            </div>
          ))}
          {etapas.length === 0 && <div style={{ fontSize: 14, color: theme.textMuted }}>Carregando…</div>}
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 14, alignItems: "center" }}>
          <button type="button" style={btn(false)} onClick={() => setEtapas((l) => [...l, { id: "", label: "Nova etapa", color: CORES[l.length % CORES.length], tipo: "contato" }])}>+ Adicionar etapa</button>
          {modelos.some((m) => (m.etapasNegociacao || []).length > 0) && (
            <select value="" onChange={(e) => { const m = modelos.find((x) => x.id === e.target.value); if (m && m.etapasNegociacao && window.confirm(`Trocar as etapas pelo modelo "${m.nome}"? Nada é salvo até você clicar em Salvar.`)) setEtapas(m.etapasNegociacao); }} style={{ ...inp, height: 40 }}>
              <option value="">Usar um modelo pronto…</option>
              {modelos.filter((m) => (m.etapasNegociacao || []).length > 0).map((m) => <option key={m.id} value={m.id}>{m.nome}</option>)}
            </select>
          )}
          <div style={{ flex: 1 }} />
          {etapasAlteradas && <button type="button" style={btn(false)} onClick={() => { setEtapas(etapasOriginal); setMoverEtapa(null); }}>Desfazer</button>}
          <button type="button" style={{ ...btn(true), opacity: etapasAlteradas && !salvandoEtapas ? 1 : 0.5 }} disabled={!etapasAlteradas || salvandoEtapas} onClick={() => salvarEtapas()}>{salvandoEtapas ? "Salvando..." : "Salvar etapas"}</button>
        </div>

        {moverEtapa && (
          <div style={{ marginTop: 16, padding: 16, borderRadius: 12, border: `1px solid ${COR}55`, background: `${COR}10` }}>
            <div style={{ fontWeight: 700, color: theme.text, marginBottom: 10 }}>Algumas etapas removidas ainda têm negociações. Para onde elas vão?</div>
            {Object.entries(moverEtapa).map(([id, v]) => (
              <div key={id} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap", color: theme.textSub, fontSize: 14 }}>
                <span><strong>{(etapasOriginal.find((s) => s.id === id) || { label: id }).label}</strong> ({v.qtd} negociaç{v.qtd > 1 ? "ões" : "ão"}) → </span>
                <select value={v.para} onChange={(e) => setMoverEtapa((m) => ({ ...m, [id]: { ...m[id], para: e.target.value } }))} style={inp}>
                  {etapas.filter((s) => s.id).map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
                </select>
              </div>
            ))}
            {etapas.some((s) => !s.id) && <div style={{ fontSize: 13, color: theme.textMuted, marginBottom: 8 }}>Etapas novas só aparecem aqui depois de salvas.</div>}
            <div style={{ display: "flex", gap: 10 }}>
              <button type="button" style={btn(true)} onClick={() => { const mapa = {}; Object.entries(moverEtapa).forEach(([id, v]) => { mapa[id] = v.para; }); salvarEtapas(mapa); }}>Mover e salvar</button>
              <button type="button" style={btn(false)} onClick={() => setMoverEtapa(null)}>Cancelar</button>
            </div>
          </div>
        )}
        {msgEtapas && <div style={{ marginTop: 14, fontSize: 14, padding: "10px 14px", borderRadius: 10, background: msgEtapas.erro ? "#ef444410" : "#00c87514", color: msgEtapas.erro ? "#ef4444" : "#00a060" }}>{msgEtapas.t}</div>}
      </div>

      <div style={card}>
        {titulo("Grupos da tela de Negociações", "Pastas para organizar as negociações na visão de lista (ex.: Em tratamento, Concluído). As mudanças aqui são salvas na hora.")}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {grupos.map((g, i) => (
            <div key={g._id} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <input type="color" defaultValue={hex(g.color)} onBlur={(e) => e.target.value !== g.color && grupoApi(() => api.put(`/grupos/${g._id}`, { color: e.target.value }))} style={quadCor} />
              <input defaultValue={g.label} maxLength={40} onBlur={(e) => { const v = e.target.value.trim(); if (v && v !== g.label) grupoApi(() => api.put(`/grupos/${g._id}`, { label: v })); }} style={{ ...inp, flex: "1 1 200px" }} />
              <button type="button" title="Subir" onClick={() => reordenarGrupos(i, -1)} style={btnIcone}>↑</button>
              <button type="button" title="Descer" onClick={() => reordenarGrupos(i, 1)} style={btnIcone}>↓</button>
              <button type="button" title="Remover" onClick={() => { if (window.confirm(`Remover o grupo "${g.label}"? As negociações dele ficam sem grupo.`)) grupoApi(() => api.delete(`/grupos/${g._id}`)); }} style={{ ...btnIcone, color: "#ef4444" }}>✕</button>
            </div>
          ))}
          {grupos.length === 0 && <div style={{ fontSize: 14, color: theme.textMuted }}>Nenhum grupo cadastrado ainda.</div>}
        </div>
        <form onSubmit={(e) => { e.preventDefault(); const v = novoGrupo.trim(); if (!v) return; setNovoGrupo(""); grupoApi(() => api.post("/grupos", { label: v, color: CORES[grupos.length % CORES.length] })); }} style={{ display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" }}>
          <input value={novoGrupo} onChange={(e) => setNovoGrupo(e.target.value)} placeholder="Nome do novo grupo" maxLength={40} style={{ ...inp, flex: "1 1 200px", height: 40 }} />
          <button type="submit" style={btn(false)}>+ Adicionar grupo</button>
        </form>
      </div>
    </div>
  );
}
